export default {"src":"/_next/static/media/hero-border.c240fe8b.svg","height":1,"width":580,"blurWidth":0,"blurHeight":0};